import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueScrollTo from 'vue-scrollto'
import { store } from './store/store'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import iFrameResize from 'iframe-resizer/js/iframeResizer'

import App from './App.vue'
import router from './router'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(VueScrollTo)

Vue.directive('resize', {
  bind: function(el, { value = {} }) {
    el.addEventListener('load', () => iFrameResize(value, el))
  }
})

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
